import { apiRequest, apiRequestEnvelope } from "./client";

export type BulkQueueItem = {
  seqId: number;
  createdAt: string;
  bulkTxId: string;
  company: string;
  totalRecipient: number;
  totalVolume: number;
};

export type ListBulkQueueParams = {
  cursor?: string | null;
  limit?: number;
};

export type ListBulkQueueResult = {
  items: BulkQueueItem[];
  cursor: string | null;
  nextCursor: string | null;
  limit: number;
  total: number;
};

export async function listBulkQueue(
  params: ListBulkQueueParams,
): Promise<ListBulkQueueResult> {
  const search = new URLSearchParams();
  if (params.cursor) search.set("cursor", params.cursor);
  if (params.limit) search.set("limit", String(params.limit));

  const envelope = await apiRequestEnvelope<{ items: BulkQueueItem[] }>({
    path: `/bulk-queue${search.toString() ? `?${search.toString()}` : ""}`,
    method: "GET",
  });

  const pagination = envelope.meta?.pagination;

  return {
    items: envelope.data?.items ?? [],
    cursor: pagination?.cursor ?? null,
    nextCursor: pagination?.nextCursor ?? null,
    limit: pagination?.limit ?? params.limit ?? 20,
    total: pagination?.total ?? 0,
  };
}

export async function executeBulkQueue(seqId: number): Promise<void> {
  await apiRequest({
    path: `/bulk-queue/${seqId}/execute`,
    method: "POST",
    body: {},
  });
}

export async function failBulkQueue(seqId: number): Promise<void> {
  await apiRequest({
    path: `/bulk-queue/${seqId}/fail`,
    method: "POST",
    body: {},
  });
}
